import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

/** Every organisation zone with roll-ups; scoped to one office when given. */
export const useZonesQuery = (officeId?: string, enabled = true) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useZonesQuery", apiClient.slug, officeId ?? ""],
    queryFn: async () => {
      const res = await apiClient.zones.list(officeId);
      return res.result;
    },
    enabled: enabled && !!apiClient.slug
  });
};

export const useZonesTreeQuery = (enabled = true) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useZonesTreeQuery", apiClient.slug],
    queryFn: async () => {
      const res = await apiClient.zones.tree();
      return res.result;
    },
    enabled: enabled && !!apiClient.slug
  });
};

export const useZonesHealthQuery = (enabled = true) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useZonesHealthQuery", apiClient.slug],
    queryFn: async () => {
      const res = await apiClient.zones.health();
      return res.result;
    },
    enabled: enabled && !!apiClient.slug
  });
};

export const useZoneQuery = (zoneId: string | null) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useZoneQuery", apiClient.slug, zoneId ?? ""],
    queryFn: async () => {
      const res = await apiClient.zones.get(zoneId ?? "");
      return res.result;
    },
    enabled: !!apiClient.slug && !!zoneId
  });
};
